import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import RedDisputeNotificationIcon from '../../assets/Red_Dispute_Notification.png';
import { selectCurrentEmpid, selectCurrentUser } from '../../pages/login/authSlice';
import { useUpdateDisqualifyApprovalMutation } from '../../pages/managerDashboard/managerDashboardSlice';
import { IDisqualifyApproval } from './approval';
import './payoutApprovalsTable.scss';
import DescriptionBox from '../descriptionBox/DescriptionBox';

export const DisqualifyApproval = (props: any) => {
    const [UpdateDisqualifyApproval] = useUpdateDisqualifyApprovalMutation();
    const [disqualifyApproval, setDisqualifyApproval] = useState(false);
    const [diaDisqualify, setDiaDisqualify] = useState(false);
    const [formFields, setFormFields] = useState<any>([]);
    const [disqualifyAppObj, setDisqualifyAppObj] = useState([]);
    const [errorMessage, setErrorMessage] = useState<any>();
    const [disableSave, setDisableSave] = useState<boolean>(true);
    const loggedUserEmpId = useSelector(selectCurrentEmpid);
    const loggedUser = useSelector(selectCurrentUser);
    const toast = useRef<Toast>(null);

    const dialogFuncMap = {
        disqualifyApproval: setDisqualifyApproval,
        diaDisqualify: setDiaDisqualify,
    };
    const onDisqualifyHide = () => {
        dialogFuncMap.disqualifyApproval(false);
        props?.closeAll(false);
    };

    const onHideDiaDisqualify = () => {
        dialogFuncMap.diaDisqualify(false);
        // closeAll(false);
    };

    const onDisqualifyClick = () => {
        let disqualifyList: IDisqualifyApproval[] = [];
        disqualifyList = formFields;
        const isformValid = validateForm();
        if (isformValid) {
            setErrorMessage('');
            setDisableSave(true);
            UpdateDisqualify(disqualifyList);
        } else {
            console.log('Error');
        }
    };

    const validateForm = (): boolean => {
        let disqualifyList: IDisqualifyApproval[] = [];
        disqualifyList = formFields;
        for (let i = 0; i < disqualifyList.length; i++) {
            const disqualify: IDisqualifyApproval = disqualifyList[i];
            if (disqualify.approvalComment === '') {
                setErrorMessage('Please enter Manager comment.');
                return false;
            }
        }
        return true;
    };

    const handleFormChange = (event: any, index: number) => {
        const data = [...formFields];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
    };

    const UpdateDisqualify = (disqualified: any) => {
        const data = {
            disqualified,
        };
        UpdateDisqualifyApproval(data)
        .unwrap()
        .then(() => {
            onDisqualifyHide();
            setDisableSave(true);
            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Save Success',
                life: 3000,
            });
        })
        .then((error: any) => {
            console.log(error);
            setDisableSave(true);
        });
    };

    useEffect(() => {
        const isformValid = validateForm();
        if (isformValid && props.disqualifyType !== '') {
            setDisableSave(false);
            setErrorMessage('');
        } else setDisableSave(true);
    }, [errorMessage, formFields]);

    useEffect(() => {
        if (props) {
            setDisqualifyApproval(props?.dialogEnable);
            setDisqualifyAppObj(props?.seletedRowData);
        }
    }, [props]);

    useEffect(() => {
        if (disqualifyAppObj?.length > 0) {
            const disqualify = disqualifyAppObj.map((item: any) => {
                const approval: IDisqualifyApproval = {
                    employeeName: item.employee_name.toString(),
                    scorecardName: item.scorecard_name.toString(),
                    currentStatus: item.overall_status,
                    newStatus: props.disqualifyType,
                    approvalComment: '',
                    approveBy: loggedUserEmpId.toString(),
                    empMonthlyResultId: item.emp_monthly_result_id,
                    payoutApprovalActionId: props.disqualifyType === 'Disqualified' ? 3 : 1,
                    applicationRoleId: 3,
                    approvalStatusId: props.disqualifyType === 'Disqualified' ? 8 : 1,
                    employeeNumber: item.employee_number.toString(),
                    actionName:
                        props.disqualifyType === 'Disqualified'
                            ? 'Manager Disqualified'
                            : 'Manager Removed Disqualification',
                };
                return approval;
            });
            setFormFields(disqualify);
            setDisableSave(false);
        }
    }, [disqualifyAppObj]);

    const disqualifyModalHeader = () => {
        return (
            <React.Fragment>
                <h5 className="pe-3">
                    <span style={{ fontSize: '16px', fontWeight: 700 }} className="pt-2">
                        Payout Status
                    </span>
                </h5>
                <span className="error-text" id="errMessage">
                    {errorMessage}
                </span>
                <Divider />
            </React.Fragment>
        );
    };

    const disqualifyModalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    className="btn-secondary me-3"
                    label="Cancel"
                    onClick={onDisqualifyHide}
                />

                <Button
                    disabled={disableSave}
                    className="btn-primary"
                    label={props.disqualifyType === 'Disqualified' ? 'Disqualify' : 'Remove Disqualification'}
                    onClick={() => setDiaDisqualify(true)}
                />
            </React.Fragment>
        );
    };

    const disqualifyDiaFooter = () => {
        return (
            <div className="text-center">
                <Button
                    className="btn-secondary me-3"
                    label="Cancel"
                    onClick={onHideDiaDisqualify}
                />

                <Button
                    className="btn-primary"
                    label={props.disqualifyType === 'Disqualified' ? 'Disqualify' : 'Remove Disqualification'}
                    onClick={onDisqualifyClick}
                />
            </div>
        );
    };

    return (
        <>
            <Dialog
                header={disqualifyModalHeader}
                visible={disqualifyApproval}
                style={{ width: '50vw' }}
                onHide={() => onDisqualifyHide()}
                className="disputeModal"
                footer={disqualifyModalFooter}
            >
                <Toast ref={toast} />
                <div className="row">
                    {formFields?.map((form: any, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                <Divider className="m-0 pb-4" />
                                <div className="card border-0">
                                    <div className="card-body p-0">
                                        <Button
                                            className="p-button text-center w-100 borderRadius"
                                            label={`Status Update ${index + 1}`}
                                        />
                                        <div className="row mt-3" key={index}>
                                            <div className="col-md-6 border-end">
                                                <h6>Employee</h6>
                                                <InputText
                                                    disabled
                                                    name="employeeName"
                                                    className="borderRadius w-100"
                                                    value={form.employeeName}
                                                />

                                                <h6 className="mt-3">Scorecard</h6>
                                                <InputText
                                                    disabled
                                                    name="scorecardName"
                                                    className="borderRadius w-100"
                                                    value={form.scorecardName}
                                                />

                                                <hr />

                                                <h6 className="mt-3">Current Status</h6>
                                                <InputText
                                                    disabled
                                                    name="currentStatus"
                                                    className="borderRadius w-100"
                                                    value={form.currentStatus}
                                                />

                                                <h6 className="mt-3">New Status</h6>
                                                <InputText
                                                    disabled
                                                    name="newStatus"
                                                    className="borderRadius w-100"
                                                    value={form.newStatus}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <DescriptionBox
                                                    title="Manager Comment"
                                                    value={form.approvalComment}
                                                    responseDescription={form.approvalComment}
                                                    onChange={(value) => {
                                                        const syntheticEvent = {
                                                            target: {
                                                                name: 'approvalComment',
                                                                value,
                                                            },
                                                        };
                                                        handleFormChange(syntheticEvent, index);
                                                    }}
                                                    limit={4000}
                                                />
                                                <div className="row disputeCommentFooterText">
                                                    <div className="col-md-6">
                                                        {new Date().toLocaleString('en-US', {
                                                            dateStyle: 'medium',
                                                        })}
                                                    </div>
                                                    <div className="col-md-6 text-end">
                                                        Added by {loggedUser}.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
            </Dialog>
            {diaDisqualify ? (
                <Dialog
                    visible={diaDisqualify}
                    style={{ width: '30vw' }}
                    onHide={() => onHideDiaDisqualify()}
                    footer={disqualifyDiaFooter}
                >
                    {props.disqualifyType === 'RemoveDisqualified' && (
                        <div className="text-center">
                            <div>
                                <img src={RedDisputeNotificationIcon} alt={''} />
                            </div>
                            <span style={{ fontSize: '24px', fontWeight: '700', color: '#E23636' }}>
                                Warning
                            </span>
                            <div style={{ textAlign: 'justify' }}>
                                <p style={{ textAlign: 'center' }}>
                                    Are you sure you want to Remove Disqualification?.
                                </p>
                            </div>
                        </div>
                    )}

                    {props.disqualifyType === 'Disqualified' && (
                        <div className="text-center">
                            <div>
                                <img src={RedDisputeNotificationIcon} alt={''} />
                            </div>
                            <span style={{ fontSize: '24px', fontWeight: '700', color: '#E23636' }}>
                                Warning
                            </span>
                            <div style={{ textAlign: 'justify' }}>
                                <p style={{ textAlign: 'center' }}>Please read below before disqualifying.</p>

                                <p style={{ fontWeight: 'normal' }}>
                                    Eligible P4P Plan Participants include all full-time and part-time regular
                                    associates who hold an “eligible position” for an eligible scorecard. A
                                    Participant will be eligible to receive an award pursuant to the P4P Plan
                                    beginning with their assignment to a scorecard
                                    <strong>
                                        {' '}
                                        as long as the Participant is still in Active Status and in Good
                                        Standing with TTEC on the last date of the Performance Period and the
                                        Participant’s employment is not involuntarily terminated before the
                                        payment of the award.
                                    </strong>
                                </p>
                            </div>
                        </div>
                    )}
                </Dialog>
            ) : (
                ''
            )}
        </>
    );
};
